import { dispatchMerchantTelemetry } from "../../shared/telemetry.js";
import type { MerchantApiClient } from "../../types.js";
import { createBillingApi, type BillingApi } from "./api.js";

export interface BillingService {
  loadStatus(): Promise<Awaited<ReturnType<BillingApi["getStatus"]>>>;
  refreshStatus(): Promise<Awaited<ReturnType<BillingApi["refreshStatus"]>>>;
}

export function createBillingService(apiClient: MerchantApiClient): BillingService {
  const api = createBillingApi(apiClient);
  return {
    loadStatus: () => track("merchant_billing_loaded", () => api.getStatus()),
    refreshStatus: () => track("merchant_billing_refreshed", () => api.refreshStatus()),
  };
}

async function track<T>(eventName: string, operation: () => Promise<T>): Promise<T> {
  const startedAt = performance.now();
  try {
    const result = await operation();
    dispatchMerchantTelemetry(eventName, {
      result: "success",
      durationMs: Math.round(performance.now() - startedAt),
    });
    return result;
  } catch (error: unknown) {
    dispatchMerchantTelemetry(eventName, {
      result: "failure",
      durationMs: Math.round(performance.now() - startedAt),
      errorName: error instanceof Error ? error.name : "unknown",
    });
    throw error;
  }
}
